import { PageContent } from '@/components';
import cn from './EmbeddedJar.styles';
import { EmbeddedJarFilters } from './EmbeddedJarFilters';
import { EmbeddedJarHeader } from './EmbeddedJarHeader';
import { EmbeddedJarList } from './EmbeddedJarList';

export const EmbeddedJar = () => {
  return (
    <div className={cn.container}>
      <EmbeddedJarHeader />
      <PageContent>
        <EmbeddedJarList />
      </PageContent>
    </div>
  );
};
